export default __webpack_public_path__ + "static/media/160.2dffdc64.jpg";